import { z } from 'zod/v4';

export const infinexEnvironments = z.enum(['dev', 'test', 'staging', 'prod']);
export type InfinexEnvironment = z.infer<typeof infinexEnvironments>;
